import { useMemo } from 'react'
import { useReminders } from '@/lib/db/rxdb/hooks'

export function useTaskReminders(
  taskId: string | null | undefined,
  workspaceId: string | null | undefined,
) {
  // Subscribe to reminders for this task, scoped to workspace
  const { reminders: allReminders, isLoading } = useReminders({
    taskId: taskId || undefined,
    envId: workspaceId || undefined,
    isDeleted: false,
  })

  // Sort reminders by creation time
  const reminders = useMemo(() => {
    if (!taskId || !workspaceId) {
      return []
    }

    return [...allReminders].sort((a, b) => a.createdOn - b.createdOn)
  }, [allReminders, taskId, workspaceId])

  // Get the first (primary) reminder for simple use cases
  const primaryReminder = reminders[0] ?? null

  return {
    reminders,
    primaryReminder,
    isLoading,
  }
}
